<template>
  <div class="quality">
    <div class="quality-content">
      <router-view></router-view>
    </div>
    <img class="quality-icon" src="../../../assets/content-box.png"/>
  </div>
</template>

<script>
export default {
  name: 'Quality',
  data () {
    return {
      transitionName: 'slide-fade'
    }
  }
}
</script>

<style scoped>
  @import "Quality.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/quality/Quality.vue